module.exports = __webpack_public_path__ + "images/cdd5b04ecc2a90e80e3ed452edbb4989-logo.png";